import type { Configuration, RedirectRequest } from '@azure/msal-browser'
import { requireEnv } from './helpers/requireEnv'

export const msalConfig: Configuration = {
  auth: {
    clientId: requireEnv('VITE_ENTRA_CLIENT_ID'),
    authority: requireEnv('VITE_ENTRA_AUTHORITY'),
    redirectUri: requireEnv('VITE_ENTRA_REDIRECT_URI'),
  },
  cache: {
    cacheLocation: 'localStorage',
  },
}

export const loginRequest: RedirectRequest = {
  scopes: [requireEnv('VITE_ENTRA_API_SCOPE')],
}

export const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL as string) ?? ''

export const requiredRole = requireEnv('VITE_ENTRA_REQUIRED_ROLE')
